import { render } from "./aboutLogistics.vue?vue&type=template&id=4e94fa95"
import script from "./aboutLogistics.vue?vue&type=script&lang=js"
export * from "./aboutLogistics.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__